/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Fire(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z"
        opacity={0.2}
      />
      <Path
        d="M179.3884,148.00007a52.03842,52.03842,0,0,1-43.388,43.38828"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M72.03592,65.35733C56.59774,88.63059,44,115.21513,44,140a84,84,0,0,0,168,0c0-52-36-92-65.17642-121.12849l-.00087.00081L112,92,72.037,65.358Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Fire;
